import { z } from "zod";

export const licenseTierSchema = z
	.string()
	.toLowerCase()
	.pipe(z.enum(["unlicensed", "basic", "essential", "professional", "enterprise"]));

export type LicenseTier = z.infer<typeof licenseTierSchema>;
